<app-header
    (selectedLanguage)="switchedLanguage($event)"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
></app-header>

<!-- ====== Banner =========== -->

<div
    class="tw-bg-[#0A0A75] tw-text-white tw-flex tw-items-center md:tw-px-[30px] tw-gap-10 tw-relative tw-pt-8 md:tw-py-4 tw-pb-0 md:tw-h-[285px] xl:tw-h-[365px]"
>
    <div class="tw-max-w-[1280px] tw-w-full tw-mx-auto">
        <!-- Left Content -->
        <div
            class="tw-text-center tw-max-w-[320px] tw-translate-y-[60px] md:tw-translate-y-0 tw-mx-auto sm:tw-mx-0 sm:tw-text-left tw-relative tw-z-10 lg:tw-max-w-[500px]"
        >
            <p
                class="tw-w-full tw-text-[26px] md:tw-text-[38px] tw-text-white tw-font-bold tw-leading-[100%] lg:tw-leading-[47px]"
            >
                {{ "INSURANCE_PAGE.HERO_TITLE" | translate }}
            </p>
            <p
                class="!tw-text-[13px] md:!tw-text-[14px] tw-mb-6 tw-font-normal tw-leading-[141%] lg:tw-leading-[22px]"
            >
                {{ "INSURANCE_PAGE.HERO_DESC" | translate }}
            </p>
        </div>

        <!-- Right Content -->
        <div
            class="tw-w-full tw-mt-[-100px] md:tw-hidden tw-flex tw-flex-col md:tw-h-full md:tw-justify-end"
        >
            <img
                src="/assets/images/insurance/banner-mob.png"
                alt="Insurance"
                class="tw-w-full tw-h-auto tw-max-h-[455px] lg:tw-max-h-[500px]"
            />
        </div>
        <img
            src="/assets/images/insurance/banner-tab.png"
            alt="Insurance"
            class="tw-w-fit tw-absolute tw-top-0 tw-right-0 tw-h-auto tw-hidden xl:tw-block md:tw-self-end md:tw-h-full md:tw-object-contain md:tw-object-bottom"
        />
        <img
            src="/assets/images/insurance/banner.png"
            alt="Insurance"
            class="tw-w-fit tw-absolute tw-top-0 tw-right-0 tw-h-auto tw-hidden md:tw-block xl:tw-hidden md:tw-self-end md:tw-h-full md:tw-object-contain md:tw-object-bottom"
        />
    </div>
</div>

<!-- ============ Services =========== -->
<div class="tw-py-[50px] lg:tw-py-[100px]">
    <div
        class="tw-max-w-[1280px] tw-px-[25px] md:tw-px-[30px] xl:tw-px-0 tw-mx-auto"
    >
        <h3
            class="!tw-text-[#0F3172] !tw-text-[22px] md:!tw-text-[28px] !tw-font-bold"
        >
            {{ "INSURANCE_PAGE.SECTION_2_HEADING" | translate }}
        </h3>
        <p class="!tw-text-[#1A202C] !tw-text-[14px]">
            {{ "INSURANCE_PAGE.SECTION_2_DESC" | translate }}
        </p>
        <!-- <p class="!tw-text-[#1A202C] !tw-text-[14px]">
            {{ "INSURANCE_PAGE.SUB_DESC_2" | translate }}
        </p> -->
    </div>
</div>
<app-insurance-benefits></app-insurance-benefits>
<section class="tw-bg-[#F9FAFF]">
    <div
        class="tw-px-[25px] md:tw-px-[30px] tw-py-10"
        (click)="closeMegaMenuCondition()"
    >
        <div class="tw-max-w-[1280px] tw-mx-auto tw-w-full">
            <p
                class="sm:tw-text-left tw-text-[22px] md:tw-text-[28px] tw-w-full tw-text-[#0F3172] tw-font-bold"
            >
                {{ "INSURANCE_PAGE.LISTING_TITLE" | translate }}
            </p>
            <p
                class="sm:tw-text-left tw-py-2 tw-text-left !tw-mt-0 !tw-mb-10 tw-text-[#1A202C]"
            >
                {{ "INSURANCE_PAGE.LISTING_DESC" | translate }}
            </p>
            <p
                class="tw-text-blue-900 !tw-font-semibold !tw-text-center !tw-my-4 tw-block sm:tw-hidden"
            >
                {{ "INSURANCE_PAGE.VIEW_PACKAGES" | translate }}
            </p>
            <h2
                class="tw-hidden sm:tw-block !tw-font-semibold !tw-text-[26px] !tw-text-[#0F3172]"
            >
                {{ "INSURANCE_PAGE.TITLE" | translate }}
            </h2>
            <div
                class="tw-hidden md:tw-flex tw-justify-center sm:tw-justify-start tw-flex-col1 md:tw-flex-row1 tw-gap-4 tw-my-9 tw-relative"
            >
                <div
                    (click)="filterProducts('Policystreet')"
                    class="tw-flex tw-flex-col tw-items-center tw-gap-2 hover:tw-cursor-pointer"
                >
                    <div
                        [ngClass]="
                            sProd === 'Policystreet'
                                ? 'tw-border tw-border-[#4B6EEC]'
                                : ''
                        "
                        class="tw-w-[150px] tw-h-[125px] sm:tw-w-[250px] sm:tw-h-[150px] shadow-sm tw-rounded-3xl tw-flex tw-justify-center tw-items-center tw-mb-2 tw-mx-auto tw-relative tw-overflow-hidden tw-border tw-border-[#00000033]"
                    >
                        <div
                            *ngIf="sProd === 'Policystreet'"
                            class="tw-flex sm:tw-hidden tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-h-full tw-w-full"
                        >
                            <img
                                class="tw-w-[50px]"
                                src="/assets/images/insurance/tick.png"
                                alt="tick"
                            />
                        </div>
                        <img
                            src="{{ imgs.policystreet }}"
                            class="tw-w-[55%]"
                            alt="Policystreet"
                        />
                    </div>
                    <p
                        class="tw-hidden !tw-text-[18px] !tw-font-bold tw-text-blue-800 tw-text-center sm:tw-flex tw-items-center tw-gap-1"
                    >
                        {{ "INSURANCE_PAGE.VIEW_PACKAGES" | translate }}
                        <mat-icon
                            class="!tw-text-[14px] !tw-h-[14px] !tw-w-[14px]"
                            >{{
                                sProd === "Policystreet"
                                    ? "keyboard_arrow_down"
                                    : "keyboard_arrow_right"
                            }}</mat-icon
                        >
                    </p>
                </div>
            </div>
            <div
                class="tw-block md:tw-hidden tw-relative tw-w-full tw-overflow-hidden tw-h-auto tw-min-h-[140px] sm:tw-min-h-[200px] tw-mx-auto"
            >
                <div class="tw-relative tw-h-full">
                    <div
                        *ngFor="let insurance of insurances; let i = index"
                        class="tw-absolute tw-top-0 tw-w-full tw-h-full tw-transition-all tw-duration-500"
                        [ngStyle]="{ left: i === currentIndex ? '0%' : '100%' }"
                    >
                        <div
                            class="tw-flex tw-justify-center tw-items-center h-full"
                        >
                            <div
                                (click)="filterProducts(insurance.key)"
                                class="tw-flex tw-flex-col tw-items-center tw-gap-2 hover:tw-cursor-pointer"
                            >
                                <div
                                    [ngClass]="
                                        sProd === insurance.key
                                            ? 'tw-border tw-border-[#4B6EEC]'
                                            : ''
                                    "
                                    class="tw-w-[200px] tw-h-[135px] shadow-sm tw-rounded-3xl tw-flex tw-justify-center tw-items-center tw-mb-2 tw-mx-auto tw-relative tw-overflow-hidden tw-border tw-border-[#00000033]"
                                >
                                    <div
                                        *ngIf="sProd === insurance.key"
                                        class="tw-flex sm:tw-hidden tw-justify-center tw-items-center tw-bg-[#00000070] tw-absolute tw-top-0 tw-left-0 tw-h-full tw-w-full"
                                    >
                                        <img
                                            class="tw-w-[50px]"
                                            src="/assets/images/insurance/tick.png"
                                            alt="tick"
                                        />
                                    </div>
                                    <img
                                        [src]="insurance.img"
                                        class="tw-w-[55%]"
                                        [alt]="insurance.key"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Slider Controls -->
                <button
                    class="tw-absolute tw-top-1/2 tw-left-2 tw-transform tw--translate-y-1/2 tw-text-[#003A70] tw-bg-white tw-text-[18px] md:tw-text-4xl tw-z-20 tw-h-[24px] md:tw-h-7 tw-w-[24px] md:tw-w-7 tw-shadow-md tw-rounded-full tw-flex tw-items-center tw-justify-center"
                    (click)="prevSlide()"
                >
                    ‹
                </button>

                <button
                    class="tw-absolute tw-top-1/2 tw-right-2 tw-transform tw--translate-y-1/2 tw-text-[#003A70] tw-bg-white tw-text-[18px] md:tw-text-4xl tw-z-20 tw-h-[24px] md:tw-h-7 tw-w-[24px] md:tw-w-7 tw-shadow-md tw-rounded-full tw-flex tw-items-center tw-justify-center"
                    (click)="nextSlide()"
                >
                    ›
                </button>
            </div>
        </div>
    </div>

    <div class="tw-px-[25px] md:tw-px-[55px] tw-py-[30px]">
        <div class="tw-mx-auto tw-max-w-[1280px] tw-w-full">
            <h2
                class="tw-hidden sm:tw-block !tw-font-semibold !tw-text-[26px] !tw-text-[#0F3172]"
            >
                {{ "INSURANCE_PAGE.ALL_PACKAGES" | translate }}
            </h2>

            <div
                class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-5 xl:tw-gap-[3rem] tw-py-6 tw-mb-[30px]"
            >
                <app-insurance-card
                    *ngFor="
                        let product of filteredProducts
                            | slice: 0 : visibleCount
                    "
                    [product]="product"
                    [selectedLanguage]="selectedLanguage"
                    (apply)="applyProduct($event)"
                />
            </div>

            <div class="tw-flex tw-justify-center tw-mb-[30px]">
                <button
                    *ngIf="visibleCount < filteredProducts.length"
                    (click)="showMore()"
                    class="tw-border tw-border-[#4B6EEC] tw-text-[#4B6EEC] tw-flex tw-items-center tw-gap-2 tw-py-2 tw-px-4 tw-rounded-full tw-mt-4"
                >
                    {{ "COMMON.VIEW_MORE" | translate }}
                    <svg
                        width="16"
                        height="10"
                        viewBox="0 0 16 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.26104 9.65986L0.306089 1.97201C0.110104 1.75537 1.84346e-06 1.46155 1.85685e-06 1.15518C1.87025e-06 0.848805 0.110105 0.554981 0.306089 0.338343C0.502075 0.121705 0.767888 -6.63534e-07 1.04505 -6.53701e-07C1.32222 -6.43869e-07 1.58803 0.121705 1.78402 0.338343L7.99913 7.21032L14.216 0.340266C14.313 0.232998 14.4282 0.147908 14.555 0.0898544C14.6818 0.0318013 14.8177 0.00192159 14.9549 0.00192159C15.0922 0.0019216 15.2281 0.0318013 15.3549 0.0898544C15.4817 0.147908 15.5969 0.232998 15.6939 0.340266C15.791 0.447534 15.8679 0.57488 15.9205 0.715033C15.973 0.855185 16 1.0054 16 1.1571C16 1.3088 15.973 1.45902 15.9204 1.59917C15.8679 1.73932 15.791 1.86667 15.6939 1.97393L8.73896 9.66178C8.64193 9.76917 8.52667 9.85432 8.3998 9.91236C8.27293 9.97039 8.13694 10.0002 7.99964 10C7.86233 9.99982 7.72641 9.96968 7.59967 9.91132C7.47292 9.85295 7.35784 9.7675 7.26104 9.65986Z"
                            fill="#4B6EEC"
                        />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</section>

<app-footer (click)="closeMegaMenuCondition()"></app-footer>
